{
  "version": 1,
  "asset_id": "7897c899-c0a4-4bc1-930c-7e0625faf234",
  "project_id": "562bff25-798c-4deb-b966-1843715c88c5",
  "url": "/__l5e/assets-v1/7897c899-c0a4-4bc1-930c-7e0625faf234/rory-portrait-clean.webp",
  "r2_key": "a/v1/562bff25-798c-4deb-b966-1843715c88c5/7897c899-c0a4-4bc1-930c-7e0625faf234/rory-portrait-clean.webp",
  "original_filename": "rory-portrait-clean.webp",
  "size": 77180,
  "content_type": "image/webp",
  "created_at": "2026-09-12T18:44:24Z"
}
